<template>
  <div>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-format-list-bulleted</v-icon>
          Log de cambios  de guía
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-chip small color="blue" dark label>
          {{ totalItems }} registros
        </v-chip>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-text-field
          v-model="filtros.awb_origen"
          @keyup.enter="cargarLista()"
          label="AWB Origen"
          single-line
          class="mt-2 mr-2"
          style="max-width: 140px"
          clearable
          @click:clear="filtros.awb_origen = null; cargarLista()"
        ></v-text-field>

        <v-text-field
          v-model="filtros.awb_destino"
          @keyup.enter="cargarLista()"
          label="AWB Destino"
          single-line
          class="mt-2 mr-2"
          style="max-width: 140px"
          clearable
          @click:clear="filtros.awb_destino = null; cargarLista()"
        ></v-text-field>

        <v-text-field
          v-model="filtros.num_guia_finca"
          @keyup.enter="cargarLista()"
          label="N° Guia Finca"
          single-line
          class="mt-2 mr-2"
          style="max-width: 140px"
          clearable
          @click:clear="filtros.num_guia_finca = null; cargarLista()"
        ></v-text-field>

        <v-text-field
          v-model="filtros.usuario"
          @keyup.enter="cargarLista()"
          label="Usuario"
          single-line
          class="mt-2 mr-2"
          style="max-width: 140px"
          clearable
          @click:clear="filtros.usuario = null; cargarLista()"
        ></v-text-field>

        <v-menu
          v-model="menuFechaDesde"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          class="mt-2 mr-2"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filtros.fecha_desde"
              label="Fecha desde"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="filtros.fecha_desde = null"
              class="mt-2"
              style="max-width: 150px"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filtros.fecha_desde"
            @change="menuFechaDesde = false"
            no-title
          ></v-date-picker>
        </v-menu>

        <v-menu
          v-model="menuFechaHasta"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          class="mt-2 mr-2"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filtros.fecha_hasta"
              label="Fecha hasta"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="filtros.fecha_hasta = null"
              class="mt-2"
              style="max-width: 150px"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filtros.fecha_hasta"
            @change="menuFechaHasta = false"
            no-title
          ></v-date-picker>
        </v-menu>

        <v-btn small color="primary" @click="cargarLista()" class="mb-2 mr-2">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.fecha="{ item }">
          {{ item.FECHA }}
        </template>
        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "CambioGuiaLog",
  data: () => ({
    headers: [
      { text: "ID", value: "ID" },
      { text: "Tipo", value: "TIPO" },
      { text: "AWB Origen", value: "AWB_ORIGEN" },
      { text: "AWB Destino", value: "AWB_DESTINO" },
      { text: "N° Guia Finca", value: "NUM_GUIA_FINCA" },
      { text: "Fecha", value: "fecha" },
      { text: "Usuario", value: "USUARIO" },
    ],
    lista: [],
    pageCount: 0,
    itemsPerPage: 40,
    currentPage: 1,
    overlay: false,
    totalItems: 0,
    menuFechaDesde: false,
    menuFechaHasta: false,
    filtros: {
      awb_origen: null,
      awb_destino: null,
      num_guia_finca: null,
      usuario: null,
      fecha_desde: null,
      fecha_hasta: null,
    },
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/cambio-guia-log");
      this.requestApi({
        method: "GET",
        data: {
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          awb_origen: this.filtros.awb_origen,
          awb_destino: this.filtros.awb_destino,
          num_guia_finca: this.filtros.num_guia_finca,
          usuario: this.filtros.usuario,
          fecha_desde: this.filtros.fecha_desde,
          fecha_hasta: this.filtros.fecha_hasta,
        },
      })
        .then((res) => {
          this.lista = res.data.lista;
          this.pageCount = res.data.pageCount;
          this.totalItems = res.data.totalItems;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    handlePageChange() {
      this.cargarLista();
    },
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Cambio Guia Log");
    this.cargarLista();
  },
};
</script>
